import  { useEffect, useRef } from 'react'
import { instructions } from './instructions-data'
import './instructions.css'
export default function Instructions (props: any, _ref:any) {

  const instructionsRef:any=useRef(null)
  useEffect (() => {
    if (instructionsRef.current){
      instructionsRef.current.focus()
    }
  }, [])

  return (
        <div ref={props?.current} className="rb-instructions">
                  <ul tabIndex={0} aria-live='polite' ref={instructionsRef}>
                    {instructions.map(items =>
                      <li key={items.link}>
                        {items.title}
                      </li>
                    )}
                </ul>
            </div>
  )
}
